module.exports = __webpack_public_path__ + "static/media/slime-bnb.647dfa95.png";